"use client"

import type React from "react"
import { useLanguage } from "./LanguageContext"
import "./css/language-switcher.css"

const LanguageSwitcher: React.FC = () => {
  const { language, changeLanguage, languages } = useLanguage()

  return (
    <div className="language-switcher">
      {Object.values(languages).map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`language-option ${lang.code === language.code ? "active" : ""}`}
          aria-label={`Switch to ${lang.name}`}
        >
          <span className="language-flag">{lang.flag}</span>
          <span>{lang.name}</span>
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher

